// import React from 'react';


// const partners = [
//   { id: 1, src: '/ECE.png', alt: 'Partner 1' },
//   { id: 2, src: '/Britannia.png', alt: 'Partner 2' },
//   { id: 3, src: '/TATA.png', alt: 'Partner 3' },
//   { id: 4, src: '/Burgerking.png', alt: 'Partner 4' },
//   { id: 5, src: '/Amazon.png', alt: 'Partner 5' },
//   { id: 6, src: '/Relince.png', alt: 'Partner 6' },
//   { id: 7, src: '/Cinema.jpeg', alt: 'Partner 7' },
//   { id: 8, src: '/FIMS.jpeg', alt: 'Partner 8' },
//   { id: 9, src: '/Chitkara.png', alt: 'Partner 9' },
//   { id: 10, src: '/CU.jpeg', alt: 'Partner 10' },
// ];

// const Partners = () => {
//   return (
//     <div className="bg-white min-h-screen p-8">
//       <h1 className="text-4xl font-bold text-left mb-6">Our Partners</h1>
      
      
//       <div className="grid grid-cols-4 gap-4 justify-items-center">
//         {partners.map(partner => (
//           <div key={partner.id} className="w-40">
//             <img 
//               src={partner.src} 
//               alt={partner.alt} 
//               className="w-full h-auto object-contain" 
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Partners;

import React from "react";

const partners = [
  { id: 1, src: "/ECE.png", alt: "ECE Industries" },
  { id: 2, src: "/Britannia.png", alt: "Britannia" },
  { id: 3, src: "/TATA.png", alt: "Tata" },
  { id: 4, src: "/Burgerking.png", alt: "Burger King" },
  { id: 5, src: "/Amazon.png", alt: "Amazon" },
  { id: 6, src: "/Relince.png", alt: "Reliance" },
  { id: 7, src: "/Cinema.jpeg", alt: "Cinema Company" },
  { id: 8, src: "/FIMS.jpeg", alt: "FIMS" },
  { id: 9, src: "/Chitkara.png", alt: "Chitkara University" },
  { id: 10, src: "/CU.jpeg", alt: "Chandigarh University" },
];

const Partners = () => {
  return (
    <section className="bg-gray-50 py-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900">
            Trusted by Leading Organizations
          </h2>
          <p className="mt-3 text-gray-600 text-lg">
            We work with industry leaders across logistics, manufacturing, retail, and education.
          </p>
        </div>

        {/* Logos Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-10 items-center">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="flex items-center justify-center bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition"
            >
              <img
                src={partner.src}
                alt={partner.alt}
                className="h-14 object-contain grayscale hover:grayscale-0 transition duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
